import { apiClient } from "../../../base/ApiClient";

export const createFunderRate = async (data) => {
  const response = await apiClient.post('/billing/funder-rates/', data);
  return response.data;
};

export const updateFunderRate = async (id, data) => {
  const response = await apiClient.put(`/billing/funder-rates/${id}/`, data);
  return response.data;
};

export const deleteFunderRate = async (id) => {
  const response = await apiClient.delete(`/billing/funder-rates/${id}/`);
  return response.data;
};

export const getFunderRates = async (funderId) => {
  const params = funderId ? { funder: funderId } : {};
  const response = await apiClient.get('/billing/funder-rates/', { params });
  return response.data;
};